An array of position openings associated with this candidate profile.
